var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ElButton',_vm._b({staticClass:"deactivate-release-button",attrs:{"icon":"el-icon-delete","type":"danger","size":"small","plain":"","loading":_vm.loading},on:{"click":_vm.confirmDeactivateRelease}},'ElButton',_vm.$attrs,false),[_vm._v("\n  "+_vm._s(_vm.$t('APP.RELEASES.DEACTIVATE_RELEASE'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }